import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import auth from "../../services/authService";
import { toast } from "react-toastify";

export default class loginBySerial extends Form {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false
        }
    };

    state = {
        data: { serial: "", serialType: "" },
        errors: {},
    };

    schema = {
        serial: Joi.string().required().error(new Error("سریال محصول اجباری است")),
        serialType: Joi.string()
    };

    doSubmit = async () => {
        const { data } = this.state;
        try {
            if (data.serialType)
                await auth.loginBySerial(data.serial, data.serialType)
            else
                await auth.loginBySerial(data.serial, "1310")
            window.location = "/";
        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                toast.error(ex.response.data.Message);
            }
            const isLoading = false;
            this.setState({ isLoading: isLoading });
        }
    };

    change = (event) => {
        let { data } = this.state;
        this.setState(data.serialType = event.target.value);
    }

    render() {
        if (auth.getCurrentUser()) return (window.location = "/");
        return (
            <div id="loginByNationalCode">
                <div className="row justify-content-center" >
                    <form onSubmit={this.handleSubmit} className="row justify-content-center" action="/" >
                        <div className="col-11 mb-4">
                            <label className="visually-hidden" htmlFor="specificSizeSelect">نوع دستگاه</label>
                            <select className="form-select form-select-lg" onChange={this.change} value={this.state.serialType} id="serialType">
                                <option value="1310">کمپرسور</option>
                                <option value="1372">کمپرسور توربینی</option>
                                <option value="1314">درایر</option>
                                <option value="1313">درایر ASME</option>
                                <option value="1320">اکسیژن ساز</option>
                                <option value="1319">نیتروژن ساز</option>
                                <option value="1309">مخزن هوای فشرده</option>
                                <option value="1346">کول تاور</option>
                                <option value="1321">تله آبگیر</option>
                            </select>
                        </div>
                 
                        <div className="col-11  mb-4">
                            {this.renderInput("serial", "", "سریال محصول", "form-control form-control-lg")}
                        </div>
                        <div className="d-grid  col-11 mx-auto">
                            {this.renderButtonWithSpinner("ورود","btn btn-primary")}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
